import connectMeStore from './connectMeStore'

function updateStatus(placement, status) {
  const connectMeState = connectMeStore.getState()
  connectMeState.modules[placement].status = status
  connectMeStore.update(connectMeState)
}

export default updateStatus
